module.exports = __webpack_public_path__ + "static/media/protecon.cd07b30c.jpg";